<div class="row" style="margin-left: 0px;margin-right: 0px;">

 
    <div class="col-md-12">
      <h4 class="title-f">Asset Details</h4>
      <div class="card-box">
        
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-4">
            <h5 class="form-lable">Asset Type :</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Reg No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Asset Description:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Engine No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Asset Cost:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Chassis No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Amount Pledged:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Additional Info:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Add</button>
           </div> -->
      
        </div>
      </div>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>Asset Type</th>
            <th>Reg No</th>
            <th>Asset Description</th>
            <th>Engine No</th>
            <th>Asset Cost</th>
            <th>Chassis No</th>
            <th>Amount Pledged</th>
            <th>Additional Info</th>
          </tr>
          <tr style="text-align: center;">
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
          </tr>
        </ng-template>
       </p-table>  </div>
    </div>
    <br>
    </div>